module.exports = __webpack_public_path__ + "img/star-rate.2f8517b7.svg";